/**
 * 条码标签模板预览模拟数据
 * 字段需与 provider.js 中定义的模板字段一致
 */
export default {
  // ===== 条码商品核心字段 =====
  name: '张强',
  logoTest: '这是一双蓝底的红色跑鞋',
  password: '12346',
  longText: '这是一双红色的蓝底跑鞋',
  Barcode: '202600006JFYD2-4',
  barCode: '202600006JFYD2-4',
  qrcode: '202600006JFYD2-4',
  Color: '红色',
  ItemNo: 'BT0001',
  Size: '34',
};
